import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { DeviceInput, ExtensionInput, ExtensionPhoneInput, MailboxInput, PhoneInput } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { createExtensionsInput } from '../helpers/bulk-configure-extensions-helper';
import { BulkExtensionDetailSaveEvent } from '../models/bulk-configure-extensions-form-submit';
import { SaveBulkExtensions, SaveBulkExtensionsVariables } from '../queries/generated/SaveBulkExtensions';
import { SaveBulkExtensionsMutation } from '../queries/save-bulk-extensions.graphql';

@Injectable({ providedIn: 'root' })
export class BulkConfigureExtensionsApiService {
   extensionFields: (keyof ExtensionInput)[] = ['name', 'number', 'type', 'accountId'];

   mailboxFields: (keyof MailboxInput)[] = ['emailAddress'];
   extensionPhoneFields: (keyof ExtensionPhoneInput)[] = [
      'displayName',
      'ringTimeout',
      'defaultPhoneNumberId',
      'phones',
   ];
   phoneFields: (keyof PhoneInput)[] = ['phoneType', 'devices','numberOfLineKeys'];
   devicesFields: (keyof DeviceInput)[] = ['deviceId'];

   constructor(private apiService: LcsApiService) {}
   create(extensionsDetails: BulkExtensionDetailSaveEvent[]): Observable<ExecutionResult<SaveBulkExtensions>> {
      const extensions = createExtensionsInput(
         extensionsDetails,
         this.extensionFields,
         this.mailboxFields,
         this.extensionPhoneFields,
         this.phoneFields,
         this.devicesFields
      );
      return this.apiService.query<SaveBulkExtensions, SaveBulkExtensionsVariables>({
         query: SaveBulkExtensionsMutation,
         variables: {
            extensions,
         },
      });
   }
}
